import React from 'react';
import { ProductCode } from '@contracts';
import PadsPaymentBoxes from './PadsPaymentBoxes';
import { useShoppingContext } from './ProductShoppingContext';
import TamponsPaymentBoxes from './TamponsPaymentBoxes';

const ProductPaymentBoxes: React.FC = () => {
  const { productHeaderData } = useShoppingContext();
  const { productCode, shopDisabled } = productHeaderData;
  const isTamponBox = productCode === ProductCode.TamponBox;
  const isPads = productCode === ProductCode.Pads;

  if (shopDisabled) {
    return null;
  }

  if (isPads) {
    return <PadsPaymentBoxes />;
  }

  if (isTamponBox) {
    return <TamponsPaymentBoxes />;
  }

  return null;
};

export default ProductPaymentBoxes;
